import React, { useContext, useEffect, useReducer } from "react";
import { api } from "../../../utils";
import { storage, functions } from "../../../utils";
import {
  AppContext,
  BuildARingContext,
} from "../../../utils/stateHandlers/contexts";
import { barReducer } from "../../../utils/stateHandlers/reducers";
import { Mobile, Default } from "../../../utils/deviceHelpers";
import states from "../../../utils/stateHandlers/initialStates";
import formatting from "../../../utils/formatHelpers";
import ProductGalleryViewer from "../components/ProductGalleryViewer";
import CustomerTestimonials from "../components/CustomerTestimonials";
import HorizontalScrollList from "../components/HorizontalScrollList";
import BreakTable from "../components/BreakTable";
import Select from "react-select";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import Skeleton from "@mui/material/Skeleton";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import BarDetailTable from "../components/barComponents/barDetailTable";
import BarTechnicalArticles from "../components/barComponents/barTechnicalArticles";

export default function BuildARing(props) {
  const { showCustomMetalMarkets, setShowCustomMetalMarkets } =
    useContext(AppContext);
  const [barState, dispatch] = useReducer(barReducer, states.initialBarState);
  const {
    pageLoaded,
    priceLoaded,
    initialGroup,
    matchingGroup,
    setting,
    shank,
    ring,
    modalOpen,
    message,
    messageType,
  } = barState;
  const baring = props.location.state ?? props.location.state.baring;
  const recentlyViewed = JSON.parse(
    storage.getSessionStorageItem("hsRecentlyViewedProducts")
  );

  const getInitialStyle = async () => {
    const detail = await api.fetch(
      `quickorder/form?style=${props.match.params.product}`
    );
    if (detail.data.compatible_styles.product_group === "SHANKS") {
      dispatch({ type: "setSetting", payload: detail.data });
      dispatch({ type: "setInitialGroup", payload: "SETTINGS" });
      dispatch({ type: "setMatchingGroup", payload: "SHANKS" });
    } else if (detail.data.compatible_styles.product_group === "SETTINGS") {
      dispatch({ type: "setShank", payload: detail.data });
      dispatch({ type: "setInitialGroup", payload: "SHANKS" });
      dispatch({ type: "setMatchingGroup", payload: "SETTINGS" });
    }

    return detail.data;
  };

  const getInitialMatch = async (style, group) => {
    const match = await api.fetch(`quickorder/form?style=${style}`);
    if (group === "SHANKS") {
      dispatch({ type: "setShank", payload: match.data });
    } else if (group === "SETTINGS") {
      dispatch({ type: "setSetting", payload: match.data });
    }

    return match.data;
  };

  const getNewMatch = async (group, style) => {
    const match = await api.fetch(`quickorder/form?style=${style}`);
    if (group === "setting") {
      dispatch({ type: "setSetting", payload: match.data });
    } else if (group === "shank") {
      dispatch({ type: "setShank", payload: match.data });
    }

    return match.data;
  };

  const makeQueryString = (initialSetting, initialShank) => {
    const quantityString = `quantity=${1}&quantity_unit=${"EA"}`;
    const settingString = `setting[product]=${initialSetting.product}&setting[dimension]=${initialSetting.dimension}&setting[carat_size]=${initialSetting.item.carat_size}&setting[finger_size]=${initialSetting.item.finger_size}&setting[material]=${initialSetting.item.material}`;
    const shankString = `shank[product]=${initialShank.product}&shank[dimension]=${initialShank.dimension}&shank[carat_size]=${initialShank.item.carat_size}&shank[finger_size]=${initialShank.item.finger_size}&shank[material]=${initialShank.item.material}`;

    dispatch({
      type: "updateQueryString",
      payload: `${quantityString}&${settingString}&${shankString}`,
    });

    return `${quantityString}&${settingString}&${shankString}`;
  };

  const updateQueryString = (setting, shank, quantity) => {
    const quantityString = `quantity=${quantity}&quantity_unit=${"EA"}`;
    const settingString = `setting[product]=${setting.settingInfo.product}&setting[dimension]=${setting.settingInfo.dimension}&setting[carat_size]=${setting.settingInfo.carat_size}&setting[finger_size]=${setting.settingInfo.finger_size}&setting[material]=${setting.settingInfo.material}`;
    const shankString = `shank[product]=${shank.shankInfo.product}&shank[dimension]=${shank.shankInfo.dimension}&shank[carat_size]=${shank.shankInfo.carat_size}&shank[finger_size]=${shank.shankInfo.finger_size}&shank[material]=${shank.shankInfo.material}`;

    dispatch({
      type: "updateQueryString",
      payload: `${quantityString}&${settingString}&${shankString}`,
    });

    return `${quantityString}&${settingString}&${shankString}`;
  };

  const getInitialRing = async (string) => {
    dispatch({ type: "setPriceLoaded", payload: false });
    const ringInfo = await api
      .fetch(`quickorder/ring?${string}`)
      .then((res) => {
        dispatch({ type: "setRing", payload: res.data });
      });
    dispatch({ type: "setPriceLoaded", payload: true });
    return ringInfo;
  };

  const getUpdatedPrice = async (newQueryString) => {
    dispatch({ type: "setPriceLoaded", payload: false });
    const updatedRing = await api
      .fetch(`quickorder/ring?${newQueryString}`)
      .then((res) => {
        if (res.isAxiosError) {
          dispatch({
            type: "setMessage",
            payload: { message: res.response.data.errors[0], type: "error" },
          });
        } else {
          dispatch({ type: "setRing", payload: res.data });
          dispatch({
            type: "setMessage",
            payload: { message: null, type: null },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
    dispatch({ type: "setPriceLoaded", payload: true });
    return updatedRing;
  };

  function priceBreaks(quantity) {
    const breakNumber =
      quantity < 10
        ? 10
        : quantity < 50
        ? 50
        : quantity < 100
        ? 100
        : quantity < 500
        ? 500
        : 0;
    return (
      <>
        {breakNumber > 0 ? (
          <Typography
            variant="h2"
            sx={{
              fontFamily: "Verdana",
              textAlign: "center",
              fontSize: "1.4rem",
              fontWeight: "800",
            }}
          >
            Save $$$ - Add {breakNumber - ring.partcode.quantity} more to reach
            the next quantity price break.
          </Typography>
        ) : (
          <Typography
            variant="h2"
            sx={{
              fontFamily: "Verdana",
              textAlign: "center",
              fontSize: "1.4rem",
              fontWeight: "800",
            }}
          >
            Enter a quantity larger than 0.
          </Typography>
        )}
      </>
    );
  }

  function addToCart() {
    const addToCartBody = {
      cart_id: storage.getStorageItem("cartId"),
      partcode: {
        karat: ring.partcode.material,
        product: ring.partcode.product,
        dimension: ring.partcode.dimension,
        finger_size: ring.partcode.finger_size,
        quantity: ring.partcode.quantity,
        quantity_unit: ring.partcode.quantity_unit,
        carat_size: ring.partcode.carat_size,
        custom_dimension: {
          sale: 1,
          terms: 1,
        },
        message: ring.partcode.message,
      },
    };
    if (!window.location.href.includes("localhost")) {
      api
        .post("cart/add", addToCartBody)
        .then()
        .catch((error) => {
          console.error("Error:", error);
        });
    } else {
      alert("On localhost.  Not adding to cart.");
    }
  }

  function resetToActualMarkets() {
    api.fetch(`metalbase/reset`).then((res) => {
      setShowCustomMetalMarkets(false);
    });
  }

  function quantityCheck(quant, fieldName) {
    if (quant === "") {
      //dispatch({ type: "updateFields", field: "quantity", payload: 0 });
    }
    dispatch({ type: "updateQuantity", payload: quant });
    const newQueryString = updateQueryString(setting, shank, quant);
    getUpdatedPrice(newQueryString);
  }

  function setMatch(group, match) {
    //when you click on a different compatible thing in the modal

    getNewMatch(group, match);
    dispatch({ type: "openMatchingStylesModal", payload: false });
  }

  function updateFields(group, field, value) {
    if (group === "setting") {
      dispatch({ type: "updateSetting", field: field, payload: value });
    } else if (group === "shank") {
      dispatch({ type: "updateShank", field: field, payload: value });
    } else {
      return;
    }
  }

  function updateTreatments(group, field, value) {
    //how does Joe need the treatment in that field?
    if (group === "setting") {
      dispatch({
        type: "updateSettingTreatment",
        field: field,
        payload: value,
      });
    } else if (group === "shank") {
      dispatch({ type: "updateShankTreatment", field: field, payload: value });
    } else {
      return;
    }
  }

  useEffect(() => {
    async function getRing() {
      const initialStyle = await getInitialStyle();
      const initialMatch = await getInitialMatch(
        initialStyle.compatible_styles.styles[0].style,
        initialStyle.compatible_styles.product_group
      );
      if (initialStyle.compatible_styles.product_group === "SHANKS") {
        const initialQueryString = makeQueryString(initialStyle, initialMatch);
        await getInitialRing(initialQueryString);
        dispatch({ type: "setPageLoaded", payload: true });
      } else {
        const initialQueryString = makeQueryString(initialMatch, initialStyle);
        await getInitialRing(initialQueryString);
        dispatch({ type: "setPageLoaded", payload: true });
      }
    }

    getRing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.style]);

  useEffect(() => {
    if (pageLoaded && ring.partcode.quantity > 0) {
      async function loadPrice() {
        const newQueryString = updateQueryString(
          setting,
          shank,
          ring.partcode.quantity
        );
        await getUpdatedPrice(newQueryString);
      }
      loadPrice();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shank.shankInfo, setting.settingInfo]);

  const SelectField = (group, type, data) => (
    <span key={data.label}>
      <Typography sx={{ fontWeight: "700", paddingBottom: ".3rem" }}>
        {data.label}
      </Typography>
      <Select
        key={data.name}
        defaultValue={data.values.map((ele) => {
          if (data.default === ele.value) {
            return ele;
          }
          return null;
        })}
        onChange={(e) => {
          type === "field"
            ? updateFields(group, data.name, e.value)
            : updateTreatments(group, data.name, e.value);
        }}
        options={data.values}
        styles={{
          multiValue: (base) => ({
            ...base,
            backgroundColor: "#cfdde9",
          }),
        }}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary25: "#cfdde9",
            primary: "#124760",
          },
        })}
      />
    </span>
  );

  const RingQuantityField = () => (
    <Stack sx={{ marginTop: "2rem" }}>
      <Typography
        sx={{
          fontWeight: "700",
          paddingBottom: ".3rem",
        }}
      >
        Quantity (EA)
      </Typography>
      <TextField
        color="primary"
        onChange={(e) => {
          quantityCheck(e.target.value);
        }}
        type="number"
        size="small"
        sx={{
          width: "100%",
          margin: "unset",
        }}
        helperText={
          <Typography variant="subtitle2">
            Please enter your quantity
          </Typography>
        }
        value={ring.partcode.quantity}
      />
    </Stack>
  );

  const SpecialInstructionsField = () => (
    <Stack>
      <Typography
        sx={{ fontWeight: "700", paddingBottom: ".3rem", marginTop: "2rem" }}
      >
        Special Instructions
      </Typography>
      <TextField
        color="primary"
        variant="outlined"
        size="small"
        sx={{
          width: "100%",
          margin: "unset",
        }}
        onChange={(e) => {
          dispatch({
            type: "updateMessage",
            payload: e.target.value,
          });
        }}
        inputProps={{
          style: {
            fontSize: 15,
            paddingBottom: 100,
          },
        }}
      />
    </Stack>
  );

  return (
    <BuildARingContext.Provider value={{ barState, dispatch }}>
      {!pageLoaded ? (
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={true}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <Container maxWidth="xl">
          <Mobile>
            <Stack spacing={2}>
              {message ? (
                <Alert variant="filled" severity={messageType}>
                  {message}
                </Alert>
              ) : (
                <>
                  <Typography
                    textAlign="center"
                    variant="h4"
                  >{`${ring.partcode.dimension}`}</Typography>
                  <Typography textAlign="center">{`${formatting["decodeHtml"](
                    shank.shankInfo.description
                  )}`}</Typography>
                  <Typography textAlign="center">{`${formatting["decodeHtml"](
                    setting.settingInfo.description
                  )}`}</Typography>
                </>
              )}
              {ring && ring.images && (
                <>
                  <ProductGalleryViewer
                    images={ring.images}
                    baring={baring}
                    error={message ? true : false}
                    errorType={
                      message === "Price Currently Unavailable"
                        ? "product"
                        : message === null
                        ? null
                        : "quantity"
                    }
                  />
                  <BarDetailTable data={ring.ringDetails} />
                </>
              )}

              {initialGroup === "SETTINGS" ? (
                <>
                  <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                    Your Chosen Setting
                  </Typography>
                  <Typography>Chosen Setting: {setting.style}</Typography>
                  <Typography>{`${formatting["decodeHtml"](
                    setting.settingInfo.description
                  )}`}</Typography>
                  <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                    {setting &&
                      setting.settingFields.map((field) => (
                        <>
                          {field.name === "quantity" ? (
                            ""
                          ) : (
                            <>{SelectField("setting", "field", field)}</>
                          )}
                        </>
                      ))}
                    {setting &&
                      setting.settingTreatments.map((treatment) => (
                        <>{SelectField("setting", "treatment", treatment)}</>
                      ))}
                  </Stack>
                  <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                    Pick A Shank
                  </Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    className="float-right"
                    color="primary"
                    onClick={() =>
                      dispatch({
                        type: "openMatchingStylesModal",
                        payload: true,
                      })
                    }
                  >
                    Pick a New Shank
                  </Button>
                  {message === "" || message === null ? (
                    <>
                      <Typography>Current Shank: {shank.style}</Typography>
                      <Typography>{`${formatting["decodeHtml"](
                        shank.shankInfo.description
                      )}`}</Typography>
                    </>
                  ) : (
                    ""
                  )}

                  <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                    {shank &&
                      shank.shankFields.map((field) => (
                        <>
                          {field.name === "quantity" ? (
                            ""
                          ) : (
                            <>{SelectField("shank", "field", field)}</>
                          )}
                        </>
                      ))}
                    {shank &&
                      shank.shankTreatments.map((treatment) => (
                        <>{SelectField("shank", "treatment", treatment)}</>
                      ))}
                  </Stack>
                </>
              ) : (
                <>
                  <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                    Your Chosen Shank
                  </Typography>
                  <Typography>Chosen Shank: {shank.style}</Typography>
                  <Typography>{`${formatting["decodeHtml"](
                    shank.shankInfo.description
                  )}`}</Typography>
                  <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                    {shank &&
                      shank.shankFields.map((field) => (
                        <>
                          {field.name === "quantity" ? (
                            ""
                          ) : (
                            <>{SelectField("shank", "field", field)}</>
                          )}
                        </>
                      ))}
                    {shank &&
                      shank.shankTreatments.map((treatment) => (
                        <>{SelectField("shank", "treatment", treatment)}</>
                      ))}
                  </Stack>
                  <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                    Pick A Setting
                  </Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    className="float-right"
                    color="primary"
                    onClick={() =>
                      dispatch({
                        type: "openMatchingStylesModal",
                        payload: true,
                      })
                    }
                  >
                    Pick a New Setting
                  </Button>
                  {message === "" || message === null ? (
                    <>
                      <Typography>Current Setting: {setting.style}</Typography>
                      <Typography>{`${formatting["decodeHtml"](
                        setting.settingInfo.description
                      )}`}</Typography>
                    </>
                  ) : (
                    <Alert variant="filled" severity={messageType}>
                      {message}
                    </Alert>
                  )}

                  <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                    {setting &&
                      setting.settingFields.map((field) => (
                        <>
                          {field.name === "quantity" ? (
                            ""
                          ) : (
                            <>{SelectField("setting", "field", field)}</>
                          )}
                        </>
                      ))}
                    {setting &&
                      setting.settingTreatments.map((treatment) => (
                        <>{SelectField("setting", "treatment", treatment)}</>
                      ))}
                  </Stack>
                </>
              )}
              <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                How many would you like?
              </Typography>
              {RingQuantityField()}
              {SpecialInstructionsField()}
              {ring.price !== "$0.00" && ring.partcode.quantity > 0 ? (
                <Typography variant="h4" sx={{ textAlign: "right" }}>
                  {message ? (
                    <Alert variant="filled" severity={messageType}>
                      {message}
                    </Alert>
                  ) : (
                    <>
                      {priceLoaded ? (
                        `${formatting["price2"](ring.price)}`
                      ) : (
                        <Skeleton
                          variant="text"
                          width="10rem"
                          className="float-right"
                        />
                      )}
                    </>
                  )}
                </Typography>
              ) : (
                <Typography variant="subtitle1">
                  Please enter a valid quantity.
                </Typography>
              )}
              {!showCustomMetalMarkets ? (
                <Typography variant="subtitle1" textAlign="right">
                  Using Actual Markets
                </Typography>
              ) : (
                <div>
                  <Typography textAlign="right">
                    Currently Using Custom Markets
                  </Typography>
                  <Typography textAlign="right">
                    If you place an order, we will NOT hold customized markets
                  </Typography>
                </div>
              )}
              {!showCustomMetalMarkets ? (
                <Typography
                  textAlign="right"
                  onClick={() => setShowCustomMetalMarkets(true)}
                  sx={{ color: "#337ab7", textDecoration: "underline" }}
                >
                  Set to custom metal markets
                </Typography>
              ) : (
                <Typography
                  onClick={() => resetToActualMarkets()}
                  textAlign="right"
                >
                  Reset to daily metal markets
                </Typography>
              )}
              <Typography
                variant="h5"
                textAlign="right"
                sx={{ color: "#337ab7", textTransform: "uppercase" }}
              >
                {ring.mto ? "MADE TO ORDER" : ""}
              </Typography>
              <Typography textAlign="right">
                Estimated ship date <strong>{ring.estimatedShipDate}</strong> if
                ordered by 5:00pm EST
              </Typography>
              {(message === "" || message === null) && (
                <Button
                  variant="contained"
                  color="success"
                  sx={{ width: "100%" }}
                  onClick={() => addToCart()}
                >
                  Add To Cart
                </Button>
              )}
              <div>{priceBreaks(ring.partcode.quantity)}</div>
              <BreakTable data={ring.pricebreaks} />
              <BarTechnicalArticles />
              <CustomerTestimonials />
              <Typography variant="h2" sx={{ marginTop: "2rem" }}>
                Recently Viewed
              </Typography>
              {recentlyViewed && (
                <HorizontalScrollList loadedStyles={recentlyViewed} />
              )}
            </Stack>
          </Mobile>
          <Default>
            <Grid container spacing={6}>
              <Grid item xs={5} sx={{ borderRight: "2px solid #e3e3e3" }}>
                {ring && ring.images && (
                  <>
                    <ProductGalleryViewer
                      images={ring.images}
                      baring={baring}
                      error={message ? true : false}
                      errorType={
                        message === "Price Currently Unavailable"
                          ? "product"
                          : message === null
                          ? null
                          : "quantity"
                      }
                    />
                    <BarDetailTable data={ring.ringDetails} />
                  </>
                )}
              </Grid>
              <Grid item xs={4}>
                {message ? (
                  <Alert variant="filled" severity={messageType}>
                    {message}
                  </Alert>
                ) : (
                  <>
                    <Typography variant="h4">{`${ring.partcode.dimension}`}</Typography>
                    <Typography>{`${formatting["decodeHtml"](
                      shank.shankInfo.description
                    )}`}</Typography>
                    <Typography>{`${formatting["decodeHtml"](
                      setting.settingInfo.description
                    )}`}</Typography>
                  </>
                )}

                {initialGroup === "SETTINGS" ? (
                  <>
                    <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                      Your Chosen Setting
                    </Typography>
                    <Typography>Chosen Setting: {setting.style}</Typography>
                    <Typography>{`${formatting["decodeHtml"](
                      setting.settingInfo.description
                    )}`}</Typography>
                    <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                      {setting &&
                        setting.settingFields.map((field) => (
                          <>
                            {field.name === "quantity" ? (
                              ""
                            ) : (
                              <>{SelectField("setting", "field", field)}</>
                            )}
                          </>
                        ))}
                      {setting &&
                        setting.settingTreatments.map((treatment) => (
                          <>{SelectField("setting", "treatment", treatment)}</>
                        ))}
                    </Stack>
                    <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                      Pick A Shank
                    </Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      className="float-right"
                      color="primary"
                      onClick={() =>
                        dispatch({
                          type: "openMatchingStylesModal",
                          payload: true,
                        })
                      }
                    >
                      Pick a New Shank
                    </Button>
                    {message === "" || message === null ? (
                      <>
                        <Typography>Current Shank: {shank.style}</Typography>
                        <Typography>{`${formatting["decodeHtml"](
                          shank.shankInfo.description
                        )}`}</Typography>
                      </>
                    ) : (
                      ""
                    )}

                    <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                      {shank &&
                        shank.shankFields.map((field) => (
                          <>
                            {field.name === "quantity" ? (
                              ""
                            ) : (
                              <>{SelectField("shank", "field", field)}</>
                            )}
                          </>
                        ))}
                      {shank &&
                        shank.shankTreatments.map((treatment) => (
                          <>{SelectField("shank", "treatment", treatment)}</>
                        ))}
                    </Stack>
                  </>
                ) : (
                  <>
                    <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                      Your Chosen Shank
                    </Typography>
                    <Typography>Chosen Shank: {shank.style}</Typography>
                    <Typography>{`${formatting["decodeHtml"](
                      shank.shankInfo.description
                    )}`}</Typography>
                    <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                      {shank &&
                        shank.shankFields.map((field) => (
                          <>
                            {field.name === "quantity" ? (
                              ""
                            ) : (
                              <>{SelectField("shank", "field", field)}</>
                            )}
                          </>
                        ))}
                      {shank &&
                        shank.shankTreatments.map((treatment) => (
                          <>{SelectField("shank", "treatment", treatment)}</>
                        ))}
                    </Stack>
                    <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                      Pick A Setting
                    </Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      className="float-right"
                      color="primary"
                      onClick={() =>
                        dispatch({
                          type: "openMatchingStylesModal",
                          payload: true,
                        })
                      }
                    >
                      Pick a New Setting
                    </Button>
                    {message === "" || message === null ? (
                      <>
                        <Typography>
                          Current Setting: {setting.style}
                        </Typography>
                        <Typography>{`${formatting["decodeHtml"](
                          setting.settingInfo.description
                        )}`}</Typography>
                      </>
                    ) : (
                      <Alert variant="filled" severity={messageType}>
                        {message}
                      </Alert>
                    )}

                    <Stack spacing={3} sx={{ marginTop: "2rem" }}>
                      {setting &&
                        setting.settingFields.map((field) => (
                          <>
                            {field.name === "quantity" ? (
                              ""
                            ) : (
                              <>{SelectField("setting", "field", field)}</>
                            )}
                          </>
                        ))}
                      {setting &&
                        setting.settingTreatments.map((treatment) => (
                          <>{SelectField("setting", "treatment", treatment)}</>
                        ))}
                    </Stack>
                  </>
                )}
                <Typography variant="h2" sx={{ marginTop: "3rem" }}>
                  How many would you like?
                </Typography>
                {RingQuantityField()}
                {SpecialInstructionsField()}
              </Grid>
              <Grid item xs={3}>
                <Stack
                  spacing={1}
                  sx={{ textAlign: "right", marginBottom: "4.5rem" }}
                >
                  {ring.price !== "$0.00" && ring.partcode.quantity > 0 ? (
                    <Typography variant="h4" sx={{ textAlign: "right" }}>
                      {message ? (
                        <Alert variant="filled" severity={messageType}>
                          {message}
                        </Alert>
                      ) : (
                        <>
                          {priceLoaded ? (
                            `${formatting["price2"](ring.price)}`
                          ) : (
                            <Skeleton
                              variant="text"
                              width="10rem"
                              className="float-right"
                            />
                          )}
                        </>
                      )}
                    </Typography>
                  ) : (
                    <Typography variant="subtitle1">
                      Please enter a valid quantity.
                    </Typography>
                  )}
                  {!showCustomMetalMarkets ? (
                    <Typography variant="subtitle1">
                      Using Actual Markets
                    </Typography>
                  ) : (
                    <div>
                      <Typography>Currently Using Custom Markets</Typography>
                      <Typography>
                        If you place an order, we will NOT hold customized
                        markets
                      </Typography>
                    </div>
                  )}
                  {!showCustomMetalMarkets ? (
                    <Typography
                      onClick={() => setShowCustomMetalMarkets(true)}
                      sx={{ color: "#337ab7", textDecoration: "underline" }}
                    >
                      Set to custom metal markets
                    </Typography>
                  ) : (
                    <Typography onClick={() => resetToActualMarkets()}>
                      Reset to daily metal markets
                    </Typography>
                  )}
                </Stack>
                <Stack
                  spacing={1}
                  sx={{ textAlign: "right", marginBottom: "8rem" }}
                >
                  <Typography
                    variant="h5"
                    sx={{ color: "#337ab7", textTransform: "uppercase" }}
                  >
                    {ring.mto ? "MADE TO ORDER" : ""}
                  </Typography>
                  <Typography>
                    Estimated ship date{" "}
                    <strong>{ring.estimatedShipDate}</strong> if ordered by
                    5:00pm EST
                  </Typography>
                  {(message === "" || message === null) && (
                    <Button
                      variant="contained"
                      color="success"
                      sx={{ width: "100%" }}
                      onClick={() => addToCart()}
                    >
                      Add To Cart
                    </Button>
                  )}
                </Stack>
                <Stack spacing={1}>
                  <div>{priceBreaks(ring.partcode.quantity)}</div>
                  <BreakTable data={ring.pricebreaks} />
                </Stack>
              </Grid>
            </Grid>
            <div style={{ marginTop: "2rem" }}>
              <BarTechnicalArticles />
              <CustomerTestimonials />
            </div>
            <Typography variant="h2" sx={{ marginTop: "2rem" }}>
              Recently Viewed
            </Typography>
            {recentlyViewed && (
              <HorizontalScrollList loadedStyles={recentlyViewed} />
            )}
          </Default>
        </Container>
      )}
      <Dialog
        open={modalOpen}
        maxWidth="md"
        onClose={() =>
          dispatch({ type: "openMatchingStylesModal", payload: false })
        }
      >
        <DialogTitle>{`Pick a matching ${
          matchingGroup === "SETTINGS" ? "Setting" : "Shank"
        }`}</DialogTitle>
        <DialogContent>
          {initialGroup === "SETTINGS" ? (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  sm: "repeat(1, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                  xl: "repeat(4, 1fr)",
                },
              }}
            >
              {setting.compatibleProducts &&
                setting.compatibleProducts.map((shank) => (
                  <Stack
                    onClick={() => setMatch("shank", shank.style)}
                    spacing={1}
                    className="pointer"
                    key={shank.style}
                  >
                    <img
                      className="related-items"
                      alt="Related Product"
                      src={shank.images[0]}
                      width="200"
                      height="200"
                    />
                    <Typography
                      className="style-text center"
                      sx={{ fontSize: "1.6rem", fontWeight: "800" }}
                    >{`${shank.style}`}</Typography>
                    <Typography
                      className="style-text center"
                      sx={{ textAlign: "center", fontSize: "1.2rem" }}
                    >
                      {formatting["decodeHtml"](shank.description)}
                    </Typography>
                    <Stack className="icon-div" spacing={1} direction="row">
                      {shank.icons.length === 0 ? (
                        <Typography className="icons" />
                      ) : (
                        shank.icons.map((icons, key) => {
                          return (
                            <Typography key={icons} className="icons">
                              {functions.getIcons(icons)}
                            </Typography>
                          );
                        })
                      )}
                    </Stack>
                  </Stack>
                ))}
            </Box>
          ) : (
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: {
                  sm: "repeat(1, 1fr)",
                  md: "repeat(2, 1fr)",
                  lg: "repeat(3, 1fr)",
                  xl: "repeat(4, 1fr)",
                },
              }}
            >
              {shank.compatibleProducts &&
                shank.compatibleProducts.map((setting) => (
                  <Stack
                    onClick={() => setMatch("setting", setting.style)}
                    spacing={1}
                    className="pointer"
                    key={setting.style}
                  >
                    <img
                      className="related-items"
                      alt="Related Product"
                      src={setting.images[0]}
                      width="200"
                      height="200"
                    />
                    <Typography
                      className="style-text center"
                      sx={{ fontSize: "1.6rem", fontWeight: "800" }}
                    >{`${setting.style}`}</Typography>
                    <Typography
                      className="style-text center"
                      sx={{ textAlign: "center", fontSize: "1.2rem" }}
                    >
                      {formatting["decodeHtml"](setting.description)}
                    </Typography>
                    <Stack className="icon-div" spacing={1} direction="row">
                      {setting.icons.length === 0 ? (
                        <Typography className="icons" />
                      ) : (
                        setting.icons.map((icons, key) => {
                          return (
                            <Typography key={icons} className="icons">
                              {functions.getIcons(icons)}
                            </Typography>
                          );
                        })
                      )}
                    </Stack>
                  </Stack>
                ))}
            </Box>
          )}
        </DialogContent>
      </Dialog>
    </BuildARingContext.Provider>
  );
}
